/*
 * Copyright (c) 2020. American Express Company
 */

// user
import { FullUserModel } from 'src/types/user.model';

export const getUser = (state: any): FullUserModel => state.user;
export const getUserPending = (state: any): boolean => state.pending;
export const getUserError = (state: any): Error => state.error;
